module.exports = __webpack_public_path__ + "static/media/button_arrow_down.5b7cf81b.svg";